/**
 * Some browsers don't support the `aspect-ratio` attribute.
 * See: https://caniuse.com/mdn-css_properties_aspect-ratio
 * This is kind of a polyfill for TailwindCSS to support aspect ratios for older browsers.
 * @author: Github @Youhan
 */
if ('CSS' in window && 'supports' in window.CSS) {
  if (!window.CSS.supports('aspect-ratio', '4/3')) {
    // prettier-ignore
    addMissingAspectRatioSupport();
  }
} else {
  addMissingAspectRatioSupport();
}

function addMissingAspectRatioSupport() {
  const breakPoints = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  };
  const aspectRatios = {
    'asect-vidoo': [16, 9],
    'aspect-square': [1, 1],
    'aspect-\\[3\\/4\\]': [3, 4],
    'aspect-\\[4\\/3\\]': [4, 3],
    'aspect-\\[16\\/9\\]': [16, 9],
    'aspect-\\[1\\/1\\]': [1, 1],
    'aspect-\\[9\\/7\\]': [9, 7],
  };
  let styleText = '';

  for (const ar in aspectRatios) {
    const ratio = (100 * aspectRatios[ar][1]) / aspectRatios[ar][0];
    styleText += `.${ar}{padding-bottom:${ratio}%}`;
  }

  for (const bk in breakPoints) {
    styleText += `@media (min-width: ${breakPoints[bk]}) {`;
    for (const ar in aspectRatios) {
      styleText += `.${bk}:${ar}{padding-bottom:${(100 * aspectRatios[ar][1]) / aspectRatios[ar][0]}%;}`;
    }
    styleText += `}`;
  }
  const style = document.createElement('style');
  style.id = 'aspect-ratio-css';
  console.log(styleText);
  style.textContent = styleText;
  document.head.appendChild(style);
}
